import { render, staticRenderFns } from "./teams.layout.vue?vue&type=template&id=27ab0204&scoped=true&"
import script from "./teams.layout.vue?vue&type=script&lang=js&"
export * from "./teams.layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ab0204",
  null
  
)

export default component.exports